import { ExportPayloadSection } from '../types';

const isNumericColumn = (
  column: ExportPayloadSection['columns'][number]
): boolean =>
  ['integer', 'float', 'number', 'numeric', 'decimal', 'double'].includes(
    column.formatConfig.type?.toLowerCase() ?? ''
  );

export default isNumericColumn;
